import { useInfiniteQuery } from 'react-query'
import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { getNextPageParam } from 'utils/getNextPageParam'
import { scheduledReviewsKeys } from './scheduledReviewsKeys'
import { ScheduledReview } from 'types'
import { buildErrorMessage } from 'utils'
import { Response } from 'request-dot-js'

interface FilterOptions {
  nextOccurrencegt?: string
  nextOccurrencelt?: string
  requester?: number | 'me'
  reviewer?: number | 'me'
  items?: number
  article?: string
}

interface Props extends FilterOptions {
  workspaceId: number
}

export const useScheduledReviews = ({
  workspaceId,
  nextOccurrencegt,
  nextOccurrencelt,
  reviewer,
  requester,
  article,
  items = 20,
}: Props) => {
  let filters = {}

  if (nextOccurrencegt || nextOccurrencelt) {
    filters = {
      nextOccurrence: [nextOccurrencegt, nextOccurrencelt],
    }
  }

  if (reviewer) {
    filters = {
      ...filters,
      reviewer,
    }
  }

  if (reviewer) {
    filters = {
      ...filters,
      requester,
    }
  }

  if (article) {
    filters = {
      ...filters,
      article,
    }
  }

  return useInfiniteQuery<Response<{ scheduled_reviews: ScheduledReview }>>(
    scheduledReviewsKeys.list(workspaceId, filters),
    async ({ pageParam = 1 }) => {
      const searchParams = new URLSearchParams(`page=${pageParam}&items=${items}`)
      if (nextOccurrencegt) {
        searchParams.set('next_occurrencegt', nextOccurrencegt)
      }
      if (nextOccurrencelt) {
        searchParams.set('next_occurrencelt', nextOccurrencelt)
      }
      if (reviewer) {
        searchParams.set('reviewer', reviewer + '')
      }
      if (requester) {
        searchParams.set('requester', requester + '')
      }
      if (article) {
        searchParams.set('article', article)
      }
      const response = await sendToApi<{ scheduled_reviews: ScheduledReview }>(
        `/w/${workspaceId}/scheduled_reviews?${searchParams.toString()}`,
      )
      if (response.type !== SUCCESS_RESPONSE_TYPE) {
        throw new Error(
          buildErrorMessage(response.data.errors) ||
            'An error occurred! Our team has been notified and we are looking into it.',
        )
      }

      return response
    },
    {
      retry: false,
      refetchOnWindowFocus: false,
      getNextPageParam,
    },
  )
}
